<template>
  <div class='text-xs leading-3 text-gray-900 bg-gray-50'>
    <div :class="padd ? 'pl-3' : ''" >
      <template v-if="children">
        <button class="flex items-center relative inline-flex items-center px-4 bg-white text-sm font-medium text-gray-700 w-full focus:outline-none">
          <!-- test svg -->
          <svg @click="expandDropdown" v-if="!this.normdevs[this.data.id].isOpen" class="ml-2 mr-2 h-5 w-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
          </svg>
          <svg @click="expandDropdown" v-if="this.normdevs[this.data.id].isOpen" class="ml-2 mr-2 h-5 w-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
          </svg>
          <div @click="toCurrentDevice(data)" class="pl-0 pr-1 py-3"> {{ name }} </div>
        </button>
      </template>
      <template v-else>
        <button @click="toCurrentDevice(data)" :class="`relative inline-flex items-center px-4 text-sm font-medium text-gray-700 w-full focus:outline-none ${currentDevice.id === data.id ? 'border-l-8 pl-2 border-yellow-500 bg-gray-100' : ''}`">
          <svg class="ml-6 mr-2 h-4 w-4" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
          </svg>
          <div class="pl-0 pr-1 py-3"> {{ name }} </div>
        </button>
      </template>
    </div>

    <div v-if="this.normdevs[this.data.id].isOpen">
        <tree-view
          v-for="child in children"
          :key="child.id"
          :name="child.name"
          :data="child"
          :paths="childPaths"
          :root="root"
          :padd="true"
        />
    </div>
  </div>
</template>

<script>
export default {
  name: 'tree-view',
  props: {
    name: String,
    data: Object,
    paths: Array,
    root: String,
    padd: Boolean
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    pathItem() {
      return this.paths[0]
    },
    children() {
      return this.data[this.pathItem]
    },
    childPaths() {
      return this.paths.slice(1)
    },
    normdevs() {
      console.log('normdevs')
      return this.$store.getters.normdevs
    },
    currentDevice() {
      return this.$store.getters.currentDevice
    }
  },
  methods: {
    isNotLastPath() {
      return this.paths.length > 1
    },
    expandDropdown() {
      this.$store.dispatch('toggleNode', this.data)
    },
    async toCurrentDevice(child) {
      await this.$store.dispatch('updateCurrentDevice', child)
    }
  },
  watch: {
    normdevs(newVal, oldVal) {
      console.log('normdevs', oldVal)
      this.isOpen = newVal[this.data.id].isOpen
    }
  }
}
</script>
